<template>
  <div class="wrapper ">
    <div class="item">
      <h1>Default props:</h1>
      <adx-gallery-slideshow :images="images" @deletedImage="delImage" @downloadedImg="downloadImg"/>
    </div>
    <div class="item">
      <h1>Custom props:</h1>
      <adx-gallery-slideshow 
        :images="images" :wrapperStyle="wrapperStyle"
        :imageStyle="imageStyle" :maxImage="maxImage" 
        :eyeIconStyle="eyeIconStyle" @deletedImage="delImage" @downloadedImg="downloadImg"/>
    </div>
    <div class="item">
      <h1>Download From Icon</h1>
      <adx-gallery-slideshow 
        :images="images2" :wrapperStyle="wrapperStyle"
        :imageStyle="imageStyle" :maxImage="maxImage" :isDownload="true"
        :eyeIconStyle="eyeIconStyle" @deletedImage="delImage" @downloadedImg="downloadImg"/>
    </div>
  </div>
</template>

<script>
import GallerySlideShow from '@/components/GallerySlideShow'

export default {
  name: 'adx-gallery-slideshow-documentation',
  components: {
    'adx-gallery-slideshow': GallerySlideShow
  },
  props: {

  },
  data() {
    return {
      maxImage: 2,
      images: [
        '/img/collection/cafe&restaurant.jpg',
        '/img/collection/airport_lounge.jpg',
        '/img/collection/gym.jpg',
        '/img/collection/office_building.jpg',
        '/img/landscape.jpg',
        '/img/portrait.jpg',
        '/img/staticpage/partnerup-join.jpg',
        '/img/staticpage/partnerup-img1.jpg',
      ],
      images2:[
        '/img/adxicon/placeholder-zip.png',
        '/img/adxicon/placeholder-zip.png'
      ],
      wrapperStyle: {
        "display": "flex",
        "flex-flow": "column"
      },
      imageStyle: {
        "width": "200px",
        "height": "200px",
        "margin-bottom": "24px"
      },
      eyeIconStyle: {
        "font-size": "32px",
        "margin-top": "85px",
        "margin-left": "85px",
      }
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    delImage(index) {
      console.log('delete image')
      this.images.splice(index, 1)
    },
    downloadImg(image_data){
      console.log('download image', image_data)
      // this.$http.get(this.url , {responseType: 'arraybuffer'})
      // .then(response => {
      //   let blob = new Blob([response.data], { type: 'application/ptestdf' })
      //   let link = document.createElement('a')
      //   link.href = window.URL.createObjectURL(blob)
      //   link.download = this.images 
      //   link.click()
      // })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>